/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  AllocationRuleGraphAndUseVersionUpsertDataRequest
} from '../../model/allocationRuleGraphAndUseVersionUpsertDataRequest'
import type {
  AllocationRuleGraphData
} from '../../model/allocationRuleGraphData'
import type {
  AllocationRuleGraphReadData
} from '../../model/allocationRuleGraphReadData'
import type {
  AllocationRuleGraphUseActivateParams
} from '../../model/allocationRuleGraphUseActivateParams'
import type {
  AllocationRuleGraphUseData
} from '../../model/allocationRuleGraphUseData'
import type {
  AllocationRuleGraphVersionTableDataRetrieveParams
} from '../../model/allocationRuleGraphVersionTableDataRetrieveParams'
import type {
  AllocationRuleGraphVersionUpsertDataRequest
} from '../../model/allocationRuleGraphVersionUpsertDataRequest'
import type {
  AllocationRuleGraphVersionUpsertResponse
} from '../../model/allocationRuleGraphVersionUpsertResponse'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Creates an allocation rule graph
 */
export const allocationRuleGraphCreate = (
    fundFamilyId: string,
    allocationRuleGraphVersionUpsertDataRequest: AllocationRuleGraphVersionUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationRuleGraphReadData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationRuleGraphVersionUpsertDataRequest
    },
      options);
    }
  


export const getAllocationRuleGraphCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphCreate>>, TError,{fundFamilyId: string;data: AllocationRuleGraphVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphCreate>>, TError,{fundFamilyId: string;data: AllocationRuleGraphVersionUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleGraphCreate>>, {fundFamilyId: string;data: AllocationRuleGraphVersionUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  allocationRuleGraphCreate(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleGraphCreateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphCreate>>>
    export type AllocationRuleGraphCreateMutationBody = AllocationRuleGraphVersionUpsertDataRequest
    export type AllocationRuleGraphCreateMutationError = unknown

    export const useAllocationRuleGraphCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphCreate>>, TError,{fundFamilyId: string;data: AllocationRuleGraphVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleGraphCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets detailed view of a given allocation rule graph
 */
export const allocationRuleGraphRetrieve = (
    fundFamilyId: string,
    allocationRuleGraphId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleGraphData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleGraphRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleGraphId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}`] as const;
    }

    
export const getAllocationRuleGraphRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphRetrieveQueryKey(fundFamilyId,allocationRuleGraphId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>> = ({ signal }) => allocationRuleGraphRetrieve(fundFamilyId,allocationRuleGraphId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>>
export type AllocationRuleGraphRetrieveQueryError = unknown

export const useAllocationRuleGraphRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphRetrieveQueryOptions(fundFamilyId,allocationRuleGraphId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleGraphRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphRetrieveQueryKey(fundFamilyId,allocationRuleGraphId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>> = ({ signal }) => allocationRuleGraphRetrieve(fundFamilyId,allocationRuleGraphId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>>
export type AllocationRuleGraphRetrieveSuspenseQueryError = unknown

export const useAllocationRuleGraphRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleGraphId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleGraphRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleGraphId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleGraphId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleGraphId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleGraphRetrieveQueryKey(fundFamilyId,allocationRuleGraphId),
              queryFn: () => allocationRuleGraphRetrieve(fundFamilyId,allocationRuleGraphId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Activates an allocation rule graph
 */
export const allocationRuleGraphActivate = (
    fundFamilyId: string,
    allocationRuleGraphId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/activate/`, method: 'PATCH'
    },
      options);
    }
  


export const getAllocationRuleGraphActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphActivate>>, TError,{fundFamilyId: string;allocationRuleGraphId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphActivate>>, TError,{fundFamilyId: string;allocationRuleGraphId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleGraphActivate>>, {fundFamilyId: string;allocationRuleGraphId: string}> = (props) => {
          const {fundFamilyId,allocationRuleGraphId} = props ?? {};

          return  allocationRuleGraphActivate(fundFamilyId,allocationRuleGraphId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleGraphActivateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphActivate>>>
    
    export type AllocationRuleGraphActivateMutationError = unknown

    export const useAllocationRuleGraphActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphActivate>>, TError,{fundFamilyId: string;allocationRuleGraphId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleGraphActivateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Returns a breakdown of allocation basis by investor for all versions for a given allocation rule graph in table format
 */
export const allocationRuleGraphVersionBasisTableDataRetrieve = (
    fundFamilyId: string,
    allocationRuleGraphId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/basis-by-version/`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleGraphVersionBasisTableDataRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleGraphId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/basis-by-version/`] as const;
    }

    
export const getAllocationRuleGraphVersionBasisTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphVersionBasisTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>> = ({ signal }) => allocationRuleGraphVersionBasisTableDataRetrieve(fundFamilyId,allocationRuleGraphId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphVersionBasisTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>>
export type AllocationRuleGraphVersionBasisTableDataRetrieveQueryError = unknown

export const useAllocationRuleGraphVersionBasisTableDataRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphVersionBasisTableDataRetrieveQueryOptions(fundFamilyId,allocationRuleGraphId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleGraphVersionBasisTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphVersionBasisTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>> = ({ signal }) => allocationRuleGraphVersionBasisTableDataRetrieve(fundFamilyId,allocationRuleGraphId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphVersionBasisTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>>
export type AllocationRuleGraphVersionBasisTableDataRetrieveSuspenseQueryError = unknown

export const useAllocationRuleGraphVersionBasisTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionBasisTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphVersionBasisTableDataRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleGraphId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleGraphVersionBasisTableDataRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleGraphId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleGraphId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleGraphId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleGraphVersionBasisTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId),
              queryFn: () => allocationRuleGraphVersionBasisTableDataRetrieve(fundFamilyId,allocationRuleGraphId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Gets detailed view of a given allocation rule graph and a given use
 */
export const allocationRuleGraphAndUseRetrieve = (
    fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<AllocationRuleGraphUseData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/use/${allocationRuleGraphUseId}/`, method: 'GET', signal
    },
      options);
    }
  

export const getAllocationRuleGraphAndUseRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/use/${allocationRuleGraphUseId}/`] as const;
    }

    
export const getAllocationRuleGraphAndUseRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphAndUseRetrieveQueryKey(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>> = ({ signal }) => allocationRuleGraphAndUseRetrieve(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId && allocationRuleGraphUseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphAndUseRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>>
export type AllocationRuleGraphAndUseRetrieveQueryError = unknown

export const useAllocationRuleGraphAndUseRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphAndUseRetrieveQueryOptions(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleGraphAndUseRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphAndUseRetrieveQueryKey(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>> = ({ signal }) => allocationRuleGraphAndUseRetrieve(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId && allocationRuleGraphUseId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphAndUseRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>>
export type AllocationRuleGraphAndUseRetrieveSuspenseQueryError = unknown

export const useAllocationRuleGraphAndUseRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string,
    allocationRuleGraphUseId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphAndUseRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleGraphAndUseRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleGraphId: string,allocationRuleGraphUseId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (fundFamilyId && allocationRuleGraphId && allocationRuleGraphUseId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleGraphAndUseRetrieveQueryKey(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId),
              queryFn: () => allocationRuleGraphAndUseRetrieve(fundFamilyId,allocationRuleGraphId,allocationRuleGraphUseId),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Returns a list of rule graph versions for a given allocation rule graph in table format
 */
export const allocationRuleGraphVersionTableDataRetrieve = (
    fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/versions/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAllocationRuleGraphVersionTableDataRetrieveQueryKey = (fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/allocation-rule-graph/${allocationRuleGraphId}/versions/`, ...(params ? [params]: [])] as const;
    }

    
export const getAllocationRuleGraphVersionTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphVersionTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>> = ({ signal }) => allocationRuleGraphVersionTableDataRetrieve(fundFamilyId,allocationRuleGraphId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphVersionTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>>
export type AllocationRuleGraphVersionTableDataRetrieveQueryError = unknown

export const useAllocationRuleGraphVersionTableDataRetrieve = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphVersionTableDataRetrieveQueryOptions(fundFamilyId,allocationRuleGraphId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllocationRuleGraphVersionTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAllocationRuleGraphVersionTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>> = ({ signal }) => allocationRuleGraphVersionTableDataRetrieve(fundFamilyId,allocationRuleGraphId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && allocationRuleGraphId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type AllocationRuleGraphVersionTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>>
export type AllocationRuleGraphVersionTableDataRetrieveSuspenseQueryError = unknown

export const useAllocationRuleGraphVersionTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    allocationRuleGraphId: string,
    params?: AllocationRuleGraphVersionTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof allocationRuleGraphVersionTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAllocationRuleGraphVersionTableDataRetrieveSuspenseQueryOptions(fundFamilyId,allocationRuleGraphId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getAllocationRuleGraphVersionTableDataRetrieveLoader = (queryParamsOrFn?: (AllocationRuleGraphVersionTableDataRetrieveParams | ((params: Params) => AllocationRuleGraphVersionTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,allocationRuleGraphId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,allocationRuleGraphId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && allocationRuleGraphId) {
            return appQueryClient.prefetchQuery({
              queryKey: getAllocationRuleGraphVersionTableDataRetrieveQueryKey(fundFamilyId,allocationRuleGraphId, queryParams),
              queryFn: () => allocationRuleGraphVersionTableDataRetrieve(fundFamilyId,allocationRuleGraphId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Upserts an allocation rule graph and use and returns the id of the newly inserted graph version
 */
export const allocationRuleGraphAndUseUpsert = (
    fundFamilyId: string,
    allocationRuleGraphAndUseVersionUpsertDataRequest: AllocationRuleGraphAndUseVersionUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<AllocationRuleGraphVersionUpsertResponse>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/use/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: allocationRuleGraphAndUseVersionUpsertDataRequest
    },
      options);
    }
  


export const getAllocationRuleGraphAndUseUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseUpsert>>, TError,{fundFamilyId: string;data: AllocationRuleGraphAndUseVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseUpsert>>, TError,{fundFamilyId: string;data: AllocationRuleGraphAndUseVersionUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleGraphAndUseUpsert>>, {fundFamilyId: string;data: AllocationRuleGraphAndUseVersionUpsertDataRequest}> = (props) => {
          const {fundFamilyId,data} = props ?? {};

          return  allocationRuleGraphAndUseUpsert(fundFamilyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleGraphAndUseUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphAndUseUpsert>>>
    export type AllocationRuleGraphAndUseUpsertMutationBody = AllocationRuleGraphAndUseVersionUpsertDataRequest
    export type AllocationRuleGraphAndUseUpsertMutationError = unknown

    export const useAllocationRuleGraphAndUseUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphAndUseUpsert>>, TError,{fundFamilyId: string;data: AllocationRuleGraphAndUseVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleGraphAndUseUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Activates an allocation rule graph use
 */
export const allocationRuleGraphUseActivate = (
    fundFamilyId: string,
    allocationRuleGraphUseId: string,
    params?: AllocationRuleGraphUseActivateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/allocation-rule-graph/use/${allocationRuleGraphUseId}/activate/`, method: 'PATCH',
        params
    },
      options);
    }
  


export const getAllocationRuleGraphUseActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphUseActivate>>, TError,{fundFamilyId: string;allocationRuleGraphUseId: string;params?: AllocationRuleGraphUseActivateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphUseActivate>>, TError,{fundFamilyId: string;allocationRuleGraphUseId: string;params?: AllocationRuleGraphUseActivateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof allocationRuleGraphUseActivate>>, {fundFamilyId: string;allocationRuleGraphUseId: string;params?: AllocationRuleGraphUseActivateParams}> = (props) => {
          const {fundFamilyId,allocationRuleGraphUseId,params} = props ?? {};

          return  allocationRuleGraphUseActivate(fundFamilyId,allocationRuleGraphUseId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AllocationRuleGraphUseActivateMutationResult = NonNullable<Awaited<ReturnType<typeof allocationRuleGraphUseActivate>>>
    
    export type AllocationRuleGraphUseActivateMutationError = unknown

    export const useAllocationRuleGraphUseActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof allocationRuleGraphUseActivate>>, TError,{fundFamilyId: string;allocationRuleGraphUseId: string;params?: AllocationRuleGraphUseActivateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getAllocationRuleGraphUseActivateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    